import {
  Component,
  ElementRef,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { CustomCertificateComponent } from '../custom-certificate/custom-certificate.component';
import { ViewCustomCssComponent } from '../custom-css/custom-css.component';
import { AdminAction } from 'src/app/models/adminaction.model';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-custom-index',
  templateUrl: './custom-index.component.html',
  styleUrls: ['./custom-index.component.scss'],
})
export class CustomIndexComponent implements OnInit {
  tabs = [
    { title: 'Custom CSS', route: '/customisation/css' },
    { title: 'Custom Certificate', route: '/customisation/certificate' },
    // Add more tabs as needed
  ];
  adminActions: AdminAction[] = [];
  @ViewChildren('hidewhenloading') hidewhenloading: QueryList<ElementRef>;

  activeTab = 0;
  constructor(public headerinfo: ComponentheaderService,private router: Router) {}

  ngOnInit() {
    let path = window.location.pathname;
    this.activeTab= this.tabs.findIndex(t=>t.route==path);

  }
  loadComponent(index) {
    this.activeTab = index;
    let tab = this.tabs[index];
    this.router.navigate([tab.route]);
  }
}
